/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import SideBar from "../components/SideBar";
import mainStyle from "../styles/mainComponents.module.css";
import styles from "../styles/equipo.module.css";
import useFetch from "../hooks/useFetch";
import { CompanyContext } from '../features/CompanyContext';
import ButtonPrincipal from "../components/ButtonPrincipal";
import ImportarEmpleadosPopup from "../components/Portals/ImportarEmpleadosPopup";
import AñadirUsuarioPopup from "../components/Portals/AñadirUsuarioPopup";
import EliminarUsuarioPopup from "../components/Portals/EliminarUsuarioPopup";
import EditarUsuarioPopup from "../components/Portals/EditarUsuarioPopup";
import EliminarEquipoPopup from "../components/Portals/EliminarEquipoPopup";
import EditarEquipoPopup from "../components/Portals/EditarEquipoPopup";
import ReiniciarEncuestaPopup from "../components/Portals/ReiniciarEncuestaPopup";
import EncuestasAnterioresPopup from "../components/Portals/EncuestasAnterioresPopup";
import { useTranslation } from "react-i18next";
import { ErrorPopup, SuccessPopup } from "../components/Popup";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader"; 

function Equipo() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { selectedCompany, selectedCompanyId, setSelectedCompany, setSelectedCompanyId } = useContext(CompanyContext);
  const { data, execute } = useFetch();
  const { data: dataPost, execute: executePost, loading: loadingPost } = useFetch();
  const { data: dataConteoCorreos, execute: executeConteoCorreos } = useFetch();
  const { execute: executeImportPost } = useFetch();
  const { execute: executeAddUsuarioPost } = useFetch();
  const { execute: executeDeleteUsuarioPost } = useFetch();
  const { execute: executeUpdateUsuarioPost } = useFetch();
  const { execute: executeSendEmail } = useFetch();
  const { execute: executeDelete } = useFetch();
  const { execute: executeEditEquipo } = useFetch();
  const { execute: executeResetSurvey } = useFetch();
  const { execute: executeReactivarEncuesta } = useFetch();
  const executeRef = useRef(execute);
  const executePostRef = useRef(executePost);
  const executeAddUsuarioPostRef = useRef(executeAddUsuarioPost);
  const executeDeleteUsuarioPostRef = useRef(executeDeleteUsuarioPost);
  const executeUpdateUsuarioPostRef = useRef(executeUpdateUsuarioPost);
  const executeDeleteRef = useRef(executeDelete);
  const executeEditEquipoRef = useRef(executeEditEquipo);
  const executeSendEmailRef = useRef(executeSendEmail);
  const executeConteoCorreosRef = useRef(executeConteoCorreos);
  const executeResetSurveyRef = useRef(executeResetSurvey);
  const executeReactivarEncuestaRef = useRef(executeReactivarEncuesta);
  const { id } = useParams();
  const [empleados, setEmpleados] = useState([]);
  const [nombreEquipo, setNombreEquipo] = useState('');
  const [isImportPopupOpen, setIsImportPopupOpen] = useState(false);
  const [isAddUserPopupOpen, setIsAddUserPopupOpen] = useState(false);
  const [isDeleteUserPopupOpen, setIsDeleteUserPopupOpen] = useState(false);
  const [isEditUserPopupOpen, setIsEditUserPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isEditEquipoPopupOpen, setIsEditEquipoPopupOpen] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToSendEmail, setUserToSendEmail] = useState(null);
  const [userToResetSurvey, setUserToResetSurvey] = useState(null);
  const [isResetSurveyPopupOpen, setIsResetSurveyPopupOpen] = useState(false);
  const [isEncuestasAnterioresPopupOpen, setIsEncuestasAnterioresPopupOpen] = useState(false);
  const [succesCreatedUser, setSuccesCreatedUser] = useState(false);
  const [errorCreatedUser, setErrorCreatedUser] = useState(false);
  const [succesDeletedUser, setSuccesDeletedUser] = useState(false);
  const [succesUpdatedUser, setSuccesUpdatedUser] = useState(false);
  const [succesImpoertedUsers, setSuccesImportedUsers] = useState(false);
  const [errorCreatedUserByOtherCompany, setErrorCreatedUserByOtherCompany] = useState(false);
  const [errorImportingUsers, setErrorImportingUsers] = useState(false);
  const [importFeedbackMessage, setImportFeedbackMessage] = useState("");
  const [succesSendEmail, setSuccesSendEmail] = useState(false);
  const [errorSendEmail, setErrorSendEmail] = useState(false);
  const [succesResetSurvey, setSuccesResetSurvey] = useState(false);
  const [errorResetSurvey, setErrorResetSurvey] = useState(false);
  const [successEditEquipo, setSuccessEditEquipo] = useState(false);
  const [errorReactivarEncuesta, setErrorReactivarEncuesta] = useState(null);
  const [nombreEmpresaEquipo, setNombreEmpresaEquipo] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [showReminderPopup, setShowReminderPopup] = useState(false);
  const [reminderMessage, setReminderMessage] = useState('');
  const [conteoCorreos, setConteoCorreos] = useState({});

  const getImportErrorMessage = (errorMessage) => {
    if (errorMessage?.includes("ya está registrado en otra empresa")) {
      return t("errorImportingUsersByOtherCompany");
    }

    return errorMessage || t("errorImportingUsers");
  };

  const fetchApiData = (url, executeRef) => {
    const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
    executeRef.current(`${apiUrl}${url}`, "GET");
  };

  const fetchApiDataPost = async (url, executeRef, body) => {
    const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
    await executeRef.current(`${apiUrl}${url}`, "POST", body);
  };
  
  const fetchApiDataDelete = async (url, executeRef, body) => {
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
      await executeRef.current(`${apiUrl}${url}`, "DELETE", body);
  };

  // Función para obtener conteo de correos por empleado
  const fetchConteoCorreos = async () => {
    try {
      await fetchApiDataPost("/gestionEncuestas/getConteoCorreosPorEmpleado", executeConteoCorreosRef, {
        id_equipo: id,
        id_empresa: selectedCompanyId,
      });
    } catch (error) {
      console.error('Error al obtener conteo de correos:', error);
    }
  };

  // Calcular si hay una encuesta activa usando useMemo para que se actualice automáticamente
  const hasActiveSurvey = useMemo(() => {
    // Verificar si hay empleados con totalPreguntas > 0, lo que indica que hay una encuesta activa
    // Cuando no hay encuesta activa, el backend devuelve totalPreguntas: 0
    return empleados && empleados.length > 0 && empleados.some(emp => 
      emp.totalPreguntas !== undefined && 
      emp.totalPreguntas !== null && 
      emp.totalPreguntas > 0
    );
  }, [empleados]);

  // Función para mostrar el popup de recordatorio
  const showReminderForNewUser = (isImport = false) => {
    if (hasActiveSurvey) {
      const message = isImport 
        ? t("reminderImportUsers") 
        : t("reminderNewUser");
      setReminderMessage(message);
      setShowReminderPopup(true);
    }
  };

  useEffect(() => {
    if (errorReactivarEncuesta) {
      const timer = setTimeout(() => setErrorReactivarEncuesta(null), 5500);
      return () => clearTimeout(timer);
    }
  }, [errorReactivarEncuesta]);

  useEffect(() => {
    executeRef.current = execute;
    executePostRef.current = executePost;
    executeConteoCorreosRef.current = executeConteoCorreos;
    executeEditEquipoRef.current = executeEditEquipo;
    executeResetSurveyRef.current = executeResetSurvey;
    executeReactivarEncuestaRef.current = executeReactivarEncuesta;
  }, [execute, executePost, executeConteoCorreos, executeEditEquipo, executeResetSurvey, executeReactivarEncuesta]);

  useEffect(() => {
    fetchApiData("/gestionCoach/getEmpresas", executeRef);
    if (id) {
      fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
        id_equipo: id
      });
    }
  }, [id]);

  useEffect(() => {
    if (dataPost) {
      setEmpleados(dataPost.empleados);
      setNombreEquipo(dataPost.equipo);
      setNombreEmpresaEquipo(dataPost.empresa);
      setSelectedCompany(dataPost.empresa);
      setSelectedCompanyId(dataPost.id_empresa);
    }
    if (dataConteoCorreos) {
      const conteoMap = {};
      dataConteoCorreos.conteoCorreos.forEach(item => {
        conteoMap[item.id_empleado] = item.conteo_correos;
      });
      setConteoCorreos(conteoMap);
    }
  }, [data, dataPost, dataConteoCorreos]);

  // useEffect separado para obtener conteo de correos cuando cambian los empleados
  useEffect(() => {
    if (hasActiveSurvey && selectedCompanyId) {
      fetchConteoCorreos();
    } else {
      // Si no hay encuesta activa, limpiar el conteo de correos
      setConteoCorreos({});
    }
  }, [hasActiveSurvey, selectedCompanyId]);

  const handleImport = async (file) => {
    setSuccesImportedUsers(false);
    setErrorImportingUsers(false);
    setImportFeedbackMessage("");
    try {
      const formData = new FormData();
        formData.append('file', file);
        formData.append('id_empresa', selectedCompanyId);
        formData.append('id_equipo', id);
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
      const response = await executeImportPost(`${apiUrl}/gestionCoach/cargar-empleados-excel`, "POST", formData, {},true);
      setImportFeedbackMessage(response?.data?.message || t("usersImported"));
      setSuccesImportedUsers(true);
      
      setTimeout(() => {
        fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
          id_equipo: id
        });
        
        // Mostrar recordatorio después de cargar los datos si hay encuesta activa
        setTimeout(() => {
          showReminderForNewUser(true);
        }, 100);
      }, 500);
    }
    catch (error) {
      console.error("Error posting to API:", error);
      setImportFeedbackMessage(getImportErrorMessage(error?.message));
      setErrorImportingUsers(true);
    }
  };

  const handleAddUser = async (user) => {
    setErrorCreatedUser(false);
    setSuccesCreatedUser(false);    
    setErrorCreatedUserByOtherCompany(false);
    try {
      await fetchApiDataPost("/gestionCoach/crearEmpleado", executeAddUsuarioPostRef, {
        id_empresa: selectedCompanyId,
        id_equipo: id,
        nombre: user.nombre,
        apellido: user.apellido,
        email: user.email,
      });
      setSuccesCreatedUser(true);
      
      setTimeout(() => {
        fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
          id_equipo: id
        });
        
        // Mostrar recordatorio después de cargar los datos si hay encuesta activa
        setTimeout(() => {
          showReminderForNewUser(false);
        }, 100);
      }, 500);
    } catch (error) {
      if (error.status === 405) {
        setErrorCreatedUserByOtherCompany(true);
        return;
      }
      console.error("Error posting to API:", error.status);
      setErrorCreatedUser(true);
    }
  };
  
  
  const handleDeleteUser = async () => {
    setSuccesDeletedUser(false);
    try {
      await fetchApiDataDelete("/gestionCoach/deleteEmpleado", executeDeleteUsuarioPostRef, {
        id_empleado: userToDelete.id_empleado,
        id_equipo: id,
      });
      setSuccesDeletedUser(true); 
      setTimeout(() => {
        fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
          id_equipo: id
        });
      }, 500);
    } catch (error) {
      console.error("Error posting to API:", error);
    }
  };

  useEffect(() => {
    if (userToSendEmail) {
      handleSendEmail();
    }
  }, [userToSendEmail]);
  
  const handleSendEmail = async () => {
    setSuccesSendEmail(false);
    setErrorSendEmail(false);
    try {
      await fetchApiDataPost("/gestionEncuestas/enviarEncuestaEmpleado", executeSendEmailRef, {
        id_empleado: userToSendEmail.id_empleado,
        id_equipo: id,
      });
      
      setSuccesSendEmail(true);
      // Recargar el conteo de correos para actualizar la tabla
      // Aumentar el tiempo de espera para producción (latencia de BD)
      setTimeout(() => {
        fetchConteoCorreos();
      }, 1000);
    } catch (error) {
      console.error("Error posting to API:", error);
      setErrorSendEmail(true);
    }
  };

  const handleResetSurvey = async () => {
    setSuccesResetSurvey(false);
    setErrorResetSurvey(false);
    try {
      await fetchApiDataPost("/gestionEncuestas/reiniciarEncuestaEmpleado", executeResetSurveyRef, {
        id_empleado: userToResetSurvey.id_empleado,
        id_equipo: id,
      });
      
      setSuccesResetSurvey(true);
      // Recargar los empleados para actualizar el porcentaje de completado
      setTimeout(() => {
        fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
          id_equipo: id,
          id_empresa: selectedCompanyId,
        });
      }, 500);
    } catch (error) {
      console.error("Error posting to API:", error);
      setErrorResetSurvey(true);
    }
  };  

  const handleUpdateUser = async (user) => {
    setSuccesUpdatedUser(false);
    try{
    await fetchApiDataPost("/gestionCoach/updateEmpleado", executeUpdateUsuarioPostRef, {
      id_empleado: user.id_empleado,
      nombre: user.nombre,
      apellido: user.apellido,
      email: user.email,
      rol: user.rol,
      id_equipo: id,
    });
    setSuccesUpdatedUser(true);
    setTimeout(() => {
      fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
        id_equipo: id
      });
    }, 500);
  }
  catch (error) {
    console.error("Error posting to API:", error);
  }
  };

  const handleDelete = async () => {
    try {
      await fetchApiDataDelete("/gestionCoach/deleteEquipo", executeDeleteRef, {
        id_equipo: id,
      });
      setTimeout(() => {
        fetchApiData("/gestionCoach/getEmpresas", executeRef);
        navigate('/empresas');
      }, 500);
    } catch (error) {
      console.error("Error posting to API:", error);
    }
  };

  const handleEditEquipo = async (nombreTrim) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
      const result = await executeEditEquipoRef.current(`${apiUrl}/gestionCoach/editarEquipo`, "POST", {
        id_equipo: id,
        nombre: nombreTrim,
      });
      setNombreEquipo(result?.equipo?.nombre ?? nombreTrim);
      setSuccessEditEquipo(true);
      setTimeout(() => setSuccessEditEquipo(false), 3000);
    } catch (err) {
      const msg = err?.response?.data?.message ?? err?.data?.message ?? err?.message ?? t("errorUpdatingTeam");
      throw new Error(msg);
    }
  };

  const handleReactivarEncuesta = async (datos) => {
    setErrorReactivarEncuesta(null);
    try {
      const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
      await executeReactivarEncuestaRef.current(`${apiUrl}/gestionEncuestas/reactivarEncuesta`, "POST", {
        id_encuesta: datos.id_encuesta,
        nueva_fecha_fin: datos.nueva_fecha_fin,
        enviar_correo: datos.enviar_correo,
        id_equipo: id,
        id_empresa: selectedCompanyId,
      });
      setSuccesResetSurvey(true);
      // Recargar los empleados para actualizar el estado
      setTimeout(() => {
        fetchApiDataPost("/gestionCoach/getEmpleados", executePostRef, {
          id_equipo: id
        });
        // Recargar el conteo de correos después de un poco más de tiempo para asegurar que los empleados se hayan actualizado
        setTimeout(() => {
          fetchConteoCorreos();
        }, 300);
      }, 500);
    } catch (error) {
      console.error("Error al reactivar encuesta:", error);
      setErrorReactivarEncuesta(error?.message || t("errorReactivarEncuesta"));
    }
  };

  return (
    <>
    <div className={mainStyle.main}>
      <SideBar selectedCompany={selectedCompany} />
      {succesCreatedUser && <SuccessPopup message={t("userCreated")}/>}
      {errorCreatedUser && <ErrorPopup message={t("errorCreatingUser")}/>}
      {succesDeletedUser && <SuccessPopup message={t("userDeleted")}/>}
      {succesUpdatedUser && <SuccessPopup message={t("userUpdated")}/>}
      {succesImpoertedUsers && <SuccessPopup message={importFeedbackMessage || t("usersImported")}/>}
      {errorImportingUsers && <ErrorPopup message={importFeedbackMessage || t("errorImportingUsers")}/>}
      {succesSendEmail && <SuccessPopup message={t("emailSent")}/>}
      {errorSendEmail && <ErrorPopup message={t("errorSendingEmail")}/>}
      {errorCreatedUserByOtherCompany && <ErrorPopup message={t("errorCreatingUserByOtherCompany")}/>}
      {succesResetSurvey && <SuccessPopup message={t("surveyReset")}/>}
      {errorResetSurvey && <ErrorPopup message={t("errorResettingSurvey")}/>}
      {successEditEquipo && <SuccessPopup message={t("teamUpdated") || "Equipo actualizado correctamente"}/>}
      {errorReactivarEncuesta && <ErrorPopup message={errorReactivarEncuesta}/>}
      {loadingPost && <Loader />}
      <div className={mainStyle.central}>
        <div className={styles.header}>
          <svg className={styles.svgDelete} onClick={() => window.history.back()} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z"/></svg>
          <p className={styles.nombreempresaEquipo}>{nombreEmpresaEquipo} <span className={styles.guionrosa}>-</span> {nombreEquipo}</p>
          <div className={styles.headerIcons}>
            <svg className={styles.svgDelete} onClick={() => setIsEditEquipoPopupOpen(true)} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" title={t("editTeam") || "Editar equipo"}><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>
            <svg className={styles.svgDelete} onClick={() => setIsDeletePopupOpen(true)} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg>
          </div>
        </div>
        <div className={styles.divCentral}>
          <div className={styles.header}>
          <input
            type="text"
            placeholder={t("search")}
            className={styles.searchInput}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          />
            <div className={styles.buttonsimport}>
              <ButtonPrincipal className={styles.button} onClick={() => setIsEncuestasAnterioresPopupOpen(true)}>
              {t("encuestasAnteriores")}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
              </ButtonPrincipal>
              <ButtonPrincipal className={styles.button} onClick={() => setIsImportPopupOpen(true)}>
              {t("import")}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"/></svg>
              </ButtonPrincipal>
              <ButtonPrincipal className={styles.button} onClick={() => setIsAddUserPopupOpen(true)}>
              {t("addUser")}
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
              </ButtonPrincipal>
            </div>
          </div>
          <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th></th>
                <th>{t("name")}</th>
                <th>{t("surname")}</th>
                <th>{t("mail")}</th>
                {hasActiveSurvey && (
                  <th>{t("CompletionPercentage")}</th>
                )}
                {hasActiveSurvey && (
                  <th style={{textAlign: 'center'}}>{t("emails")}</th>
                )}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {empleados && empleados.length > 0 ? (
                empleados
                  .filter((employee) =>
                    employee.nombre.toLowerCase().includes(searchTerm) ||
                    employee.apellido.toLowerCase().includes(searchTerm) ||
                    employee.email.toLowerCase().includes(searchTerm)
                  )
                  .map((employee) => (
                    <tr key={employee.id_empleado}>
                      <td data-label=" ">
                        {employee.rol === 'responsable' && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="16px"
                            viewBox="0 0 24 24"
                            width="16px"
                            style={{ verticalAlign: 'middle' }}
                            className={styles.responsibleIcon}
                          >
                            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5C14 14.17 9.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 2.03 1.97 3.45V19h4v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                          </svg>
                        )}
                      </td>
                      <td data-label={t("name")}>{employee.nombre}</td>
                      <td data-label={t("surname")}>{employee.apellido}</td>
                      <td data-label={t("mail")}>{employee.email}</td>
                      {hasActiveSurvey && (
                        <td data-label={t("CompletionPercentage")}>
                          <div className={styles.porcentajeCompletadoContainer}>
                            <span
                              className={employee.porcentajeCompletado === 100 ? styles.greenCircle : employee.porcentajeCompletado > 0 ? styles.yellowCircle : styles.redCircle}
                            ></span>
                            <span>{employee.porcentajeCompletado || 0}%</span>
                          </div>
                        </td>
                      )}
                      {hasActiveSurvey && (
                        <td data-label={t("emails")} style={{textAlign: 'center'}}>
                          <span className={conteoCorreos[employee.id_empleado] === 0 ? styles.conteoZero : styles.conteoNormal}>
                            {conteoCorreos[employee.id_empleado] || 0}
                          </span>
                        </td>
                      )}
                      <td data-label=" ">
                        <div className={styles.actionIcons}>
                          <button onClick={() => { setUserToDelete(employee); setIsDeleteUserPopupOpen(true); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#5f6368"><path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/></svg>
                          </button>
                          <button onClick={() => { setUserToEdit(employee); setIsEditUserPopupOpen(true); }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#5f6368"><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>
                          </button>
                          {hasActiveSurvey && employee.porcentajeCompletado !== undefined && employee.porcentajeCompletado !== null && employee.porcentajeCompletado < 100 && (
                            <button onClick={() => setUserToSendEmail(employee)}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="22px" fill="#5f6368">
                                <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z"/>
                              </svg>                        
                            </button>
                          )}
                          {hasActiveSurvey && employee.porcentajeCompletado !== undefined && employee.porcentajeCompletado !== null && employee.porcentajeCompletado > 0 && (
                            <button onClick={() => { setUserToResetSurvey(employee); setIsResetSurveyPopupOpen(true); }}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#5f6368">
                                <path d="M0 0h24v24H0z" fill="none"/>
                                <path d="M17.65 6.35a7.95 7.95 0 0 0-5.65-2.35c-4.42 0-8 3.58-8 8h2c0-3.31 2.69-6 6-6 1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35zM6.35 17.65A7.95 7.95 0 0 0 12 20c4.42 0 8-3.58 8-8h-2c0 3.31-2.69 6-6 6-1.66 0-3.14-.69-4.22-1.78L11 13H4v7l2.35-2.35z"/>
                              </svg>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
              ) : (
                <tr>
                  <td colSpan={hasActiveSurvey ? "7" : "5"}>{t("noEmpleadosDisponibles")}</td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
          </div>
        </div>
      </div>
      {isImportPopupOpen && (
        <ImportarEmpleadosPopup
          onClose={() => setIsImportPopupOpen(false)}
          onImport={handleImport}
        />
      )}
      {isAddUserPopupOpen && (
        <AñadirUsuarioPopup
          onClose={() => setIsAddUserPopupOpen(false)}
          onCreate={handleAddUser}
        />
      )}
      {isDeleteUserPopupOpen && userToDelete && (
        <EliminarUsuarioPopup
          onClose={() => setIsDeleteUserPopupOpen(false)}
          onDelete={handleDeleteUser}
          userName={`${userToDelete.nombre} ${userToDelete.apellido}`}
        />
      )}
      {isEditUserPopupOpen && userToEdit && (
        <EditarUsuarioPopup
          onClose={() => setIsEditUserPopupOpen(false)}
          onUpdate={handleUpdateUser}
          user={userToEdit}
        />
      )}
      {isEditEquipoPopupOpen && (
        <EditarEquipoPopup
          onClose={() => setIsEditEquipoPopupOpen(false)}
          onUpdate={handleEditEquipo}
          currentName={nombreEquipo}
        />
      )}
      {isDeletePopupOpen && (
        <EliminarEquipoPopup
          onClose={() => setIsDeletePopupOpen(false)}
          onDelete={handleDelete}
          companyName={nombreEquipo}
        />
      )}
      {isResetSurveyPopupOpen && userToResetSurvey && (
        <ReiniciarEncuestaPopup
          onClose={() => {
            setIsResetSurveyPopupOpen(false);
            setUserToResetSurvey(null);
          }}
          onReset={handleResetSurvey}
          userName={`${userToResetSurvey.nombre} ${userToResetSurvey.apellido}`}
        />
      )}
      {isEncuestasAnterioresPopupOpen && (
        <EncuestasAnterioresPopup
          onClose={() => setIsEncuestasAnterioresPopupOpen(false)}
          idEquipo={id}
          idEmpresa={selectedCompanyId}
          onReactivar={handleReactivarEncuesta}
        />
      )}
      {showReminderPopup && (
        <div className={styles.reminderOverlay}>
          <div className={styles.reminderPopup}>
            <div className={styles.reminderHeader}>
              <h2>{t("reminderTitle")}</h2>
            </div>
            <div className={styles.reminderContent}>
              <div className={styles.reminderIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#ffc107">
                  <path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm-40-200h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Z"/>
                </svg>
              </div>
              <p>{reminderMessage}</p>
            </div>
            <div className={styles.reminderFooter}>
              <button 
                className={styles.reminderButton}
                onClick={() => setShowReminderPopup(false)}
              >
                {t("close")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Equipo;
